import gql from 'graphql-tag';

export const dashboardDokkioLabelFragment = gql`
  fragment dashboardDokkioLabelFragment on DashboardDokkioLabel {
    dokkioClass
    id
    name
  }
`;
export default dashboardDokkioLabelFragment;
